import { u as p } from "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const l = (o) => o != null ? o : p;
export {
  l as p
};
